import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { Popover, Tooltip } from 'antd';
import { getCompanyTextColor } from '../../../utils';
import removeIconNew from '../../../assets/img/gantt/X.png';
import addResponsable from '../../../assets/img/gantt/assignee-new.png';
import { trackingEvent } from '../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../analytics/utils';
import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const subcontractIdCol = (gantt, t, fieldNoPermission, triggerSetter, cursorCustomStyle) => ({
  name: 'subcontractId',
  label: 'Subcontrato',
  data_type: 'array/string',
  visible: true,
  hide: !isColumnVisibleByDefault('subcontractId'),
  span: 2,
  offset: 0,
  align: 'center',
  mode: 'single',
  width: 180,
  groupable: false,
  from_values: 'subContracts',
  groupable_switch: ['1 → N', 'N → 1'],
  orderable: false,
  orderable_switch: ['1 → N', 'N → 1'],
  filterable: true,
  avoid_translate: true,
  resize: true,
  template: (task) => {
    const gantt = window.to_use_react_gantt;
    const column = 'subcontractId';
    if (!gantt) {
      return;
    }

    const statusObject = gantt.subContracts?.find(
      (e) => e.id === task[column]
    );
    if (!statusObject) {
      return;
    }

    const { name: companyName, color: companyColor } = statusObject;
    const companyIcon = (
      <div
        className="company-column-template__icon"
        style={{ background: companyColor }}></div>
    );
    const companyTemplate = (
      <div className="company-column-template subcontract-border cut-text-and-dot">
        {companyIcon}
        <p className="company-column-template__text">{companyName}</p>
      </div>
    );

    const companyTemplateString =
      ReactDOMServer.renderToStaticMarkup(companyTemplate);
    return companyTemplateString;
  },
  onrender: (task, node) => {
    const gantt = window.to_use_react_gantt;
    if (!gantt) return;
    let isOdd = false;
    if (gantt.oddColsConfig) {
      isOdd = gantt.oddColsConfig.subcontractId;
    }
    const column = 'subcontractId';
    /** To avoid complex code, just use uncontrolled dom elements through a ref */
    let popRef = null;
    // const subContractObject = gantt.subContracts.find(sub => sub.id == activity.subcontractId)
    const statusObject = gantt.subContracts?.find(
      (e) => e.id === task[column]
    );
    const colorObject = statusObject ? statusObject.color : null;
    return (
      <div
        className={`react-dhtmlx ${isOdd ? 'odd-col' : 'non-odd-col'}`}
        style={{ height: '100%', ...cursorCustomStyle }}>
        <Popover
          placement="bottom"
          ref={(r) => {
            popRef = r;
          }}
          overlayClassName="popover-subcontract custom-gantt-subcontract"
          className="popover-subcontract react-dhtmlx custom-gantt-subcontract"
          content={
            <div
              className="subcontracts-options"
              style={{
                overflow: 'auto'
              }}>
              <div
                style={{
                  alignContent: 'center',
                  textAlign: 'center',
                  position: 'relative',
                  top: 9,
                  height: 36
                }}
                className="add-subcontract-inline"
                onClick={() => {
                  if (popRef) {
                    popRef.tooltip.setState({ visible: false });
                    window.to_use_react_gantt.render();
                  }
                  gantt.toHardAssignSubcontract = task.id;
                  gantt.setVisibleFormSubcontract(true);
                }}>
                {t('create_subcontract_label')}
              </div>
              {gantt.subContracts.map((option, index) => (
                <span
                  className="item-gantt"
                  key={index}
                  onClick={() => {
                    if (popRef) {
                      task[column] = option.id;
                      trackingEvent(
                        'activity_company_entry',
                        {
                          ...getBasicAmplitudEventProperties(),
                          activity_name: task?.text,
                          activity_id: task?.id,
                          activity_index: task?.correlative_id
                        },
                        AMPLITUDE_SERVICE
                      );
                      popRef.tooltip.setState({ visible: false });
                      if (
                        window.to_use_react_gantt
                          .visualizationColorActive == 'subcontract'
                      ) {
                        window.to_use_react_gantt.defineColorBySubcontract(
                          task,
                          true
                        );
                      } else {
                        window.to_use_react_gantt.render();
                      }
                    }
                  }}>
                  <div
                    className="subcontract-border cut-text-and-dot"
                    style={{
                      height: '100%',
                      color: `${getCompanyTextColor(option.color)}`,
                      padding: 0,
                      backgroundColor: option.color
                    }}>
                    <div
                      className="text-subcontract cut-text-and-dot"
                      style={{
                        alignContent: 'center',
                        textAlign: 'center',
                        position: 'relative',
                        top: 7
                      }}>
                      {option.name}
                    </div>
                  </div>
                </span>
              ))}
              <div
                style={{
                  alignContent: 'center',
                  textAlign: 'center',
                  position: 'relative',
                  top: 7,
                  height: 36
                }}
                className="add-subcontract-inline"
                onClick={() => {
                  gantt.ext.undo.saveState(task.id, 'task');
                  task[column] = null;
                  if (popRef) {
                    popRef.tooltip.setState({ visible: false });

                    if (
                      window.to_use_react_gantt.visualizationColorActive ==
                      'subcontract'
                    ) {
                      window.to_use_react_gantt.defineColorBySubcontract(
                        task,
                        true
                      );
                    } else {
                      gantt.updateTask(task.id);
                    }
                  }
                }}>
                <span
                  style={{
                    position: 'relative',
                    left: -7
                  }}>
                  <img width="10" src={removeIconNew} />
                </span>
                <span
                  style={{
                    color: '#121212'
                  }}>
                  {t('remove_subcontract_label')}
                </span>
              </div>
            </div>
          }
          trigger={triggerSetter}>
          <div style={{ height: '100%' }}>
            {statusObject ? (
              <div
                className="subcontract-border cut-text-and-dot"
                style={{
                  height: '100%',
                  color: `${getCompanyTextColor(statusObject.color)}`,
                  padding: 0,
                  backgroundColor: colorObject
                }}>
                <Tooltip title={statusObject.name} placement="top">
                  <span className="text-subcontract">
                    <div
                      style={{
                        backgroundColor: colorObject
                      }}
                      className="pre-text-subcontract">
                      &nbsp;
                    </div>
                    {statusObject.name}
                  </span>
                </Tooltip>
              </div>
            ) : (
              <div
                className="opacity-hover-style"
                style={{ width: '100%', height: '100%' }}>
                <span
                  className="add-responsable-new"
                  style={cursorCustomStyle}>
                  <img width="10" src={addResponsable} />
                </span>
              </div>
            )}
          </div>
        </Popover>
      </div>
    );
  }
});

export default subcontractIdCol;